import { useI18n } from '@/context/I18nContext';

const TYPE_COLORS: Record<string, { bg: string; text: string }> = {
  final:       { bg: 'bg-amber-500/15', text: 'text-amber-400' },
  qualifying:  { bg: 'bg-blue-500/15',  text: 'text-blue-400' },
  'heat-1':    { bg: 'bg-emerald-500/15', text: 'text-emerald-400' },
  'heat-2':    { bg: 'bg-violet-500/15',  text: 'text-violet-400' },
  'heat-3':    { bg: 'bg-rose-500/15',    text: 'text-rose-400' },
  'heat-ab':   { bg: 'bg-emerald-500/15', text: 'text-emerald-400' },
  'heat-bc':   { bg: 'bg-violet-500/15',  text: 'text-violet-400' },
  'heat-ac':   { bg: 'bg-rose-500/15',    text: 'text-rose-400' },
};

const DEFAULT_COLORS = { bg: 'bg-bg-surface', text: 'text-text-secondary' };

interface SessionTypeBadgeProps {
  sessionType: string;
  size?: 'sm' | 'md';
}

export function SessionTypeBadge({ sessionType, size = 'sm' }: SessionTypeBadgeProps) {
  const { t } = useI18n();
  const colors = TYPE_COLORS[sessionType] || DEFAULT_COLORS;
  const label = t(`races.sessionType.${sessionType}` as any) || sessionType;

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${colors.bg} ${colors.text} ${
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs'
      }`}
    >
      {label}
    </span>
  );
}
